import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

/**
 * An <img> that prefers the thumbnail and quietly falls back to the original.
 *
 * Thumbnails are generated on upload and backfilled by
 * scripts/generate_thumbnails.py, so for a while some listings have one and
 * some don't. Rather than probing, we just request the thumbnail and swap to
 * the full photo if it 404s — the fallback costs one wasted request on old
 * listings and nothing at all on new ones.
 */
export default function PhotoImage({ src, fallbackSrc, alt, sx, ...rest }) {
  const [current, setCurrent] = useState(src || fallbackSrc);
  const [failed, setFailed] = useState(false);

  // A card can be recycled onto a different listing while mounted.
  useEffect(() => {
    setCurrent(src || fallbackSrc);
    setFailed(false);
  }, [src, fallbackSrc]);

  const handleError = () => {
    if (!failed && fallbackSrc && current !== fallbackSrc) {
      setFailed(true);
      setCurrent(fallbackSrc);
    }
  };

  if (!current) return null;

  return (
    <Box
      component="img"
      src={current}
      alt={alt || ""}
      onError={handleError}
      sx={sx}
      {...rest}
    />
  );
}
